import { WretcherResponse } from 'wretch/dist/resolver';

export const NO_REFRESH_TOKEN = 'No refresh token available';
export const COULD_NOT_REFRESH_TOKEN = 'Could not refresh token';
export const NOT_LOGGED_IN = 'Not logged in';

export enum EResponseStatus {
  UNAUTHORIZED = 401,
}

export const isUnauthorized = (response: WretcherResponse) =>
  response.status === EResponseStatus.UNAUTHORIZED;
